import React, { useCallback, useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";

const VERSION_BANNER_PENDING_VERSION_KEY = "versionBannerPendingVersion";

const AppVersionBanner = () => {
  const [open, setOpen] = useState(false);
  const [targetVersion, setTargetVersion] = useState(null);

  const reload = useCallback(() => {
    if (targetVersion) {
      sessionStorage.setItem(VERSION_BANNER_PENDING_VERSION_KEY, targetVersion);
    }

    window.location.reload();
  }, [targetVersion]);

  useEffect(() => {
    const handleVersionChanged = event => {
      setTargetVersion(event.detail?.serverVersion ?? null);
      setOpen(true);
    };

    window.addEventListener("app-version-changed", handleVersionChanged);
    return () => window.removeEventListener("app-version-changed", handleVersionChanged);
  }, []);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        icon={false}
        severity="info"
        variant="filled"
        sx={{ background: "#282c33", color: "#fff" }}
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          New updates are available.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
         Save your work, then refresh to apply the latest changes.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Button
            size="small"
            component="a"
            href="/release-notes"
            sx={{ color: "#fff", textDecoration: "underline" }}
          >
            View Release Notes
          </Button>
          <Button
            size="medium"
            variant="contained"
            sx={{ background: "#fff", color: "#282c33", fontWeight: 500, "&:hover": { background: "#e0e0e0" } }}
            onClick={reload}
          >
            Refresh
          </Button>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default AppVersionBanner;
